function SetRangeOnFocusDirective() {
  return {
    restrict: 'A',
    link: (scope, element) => {
      element.on('keydown', function (event) {
        if (event.shiftKey) {
          event.preventDefault();
          return false;
        }

        // console.log(event.which);

        if ([8, 13, 27, 37, 38, 39, 40, 9].indexOf(event.which) > -1) {
          // backspace, enter, escape, arrows, tab
          return true;
        } else if (event.which >= 48 && event.which <= 57) {
          // numbers 0 to 9
          return true;
        } else if (event.which >= 96 && event.which <= 105) {
          // numpad number
          return true;
        }

        event.preventDefault();
        return false;
      });
    }
  };
}

SetRangeOnFocusDirective.$inject = [];

export default SetRangeOnFocusDirective;



// WEBPACK FOOTER //
// ./src/directives/onlyNumbers.js